import { Observable, pipe, throwError, timeout, UnaryFunction } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { StatusCode } from '../models/status-code';

const ONE_MINUTE = 60_000; // ms

/**
 * Make sure the call times out if the response doesn't come quickly enough and
 * map errors to the Response type to simplify error handling downstream.
 *
 * This one is for BEFORE getting the response body.
 *
 */
export function normalizeCallBehavior(): UnaryFunction<
  Observable<Response>,
  Observable<Response>
> {
  return pipe(
    catchError<Response, Observable<Response>>((error) =>
      throwError(() =>
        error instanceof Response
          ? error
          : new Response(null, {
              status: StatusCode.NetworkError,
              statusText: 'Network Error',
            })
      )
    ),
    timeout<Response, Observable<Response>>({
      each: ONE_MINUTE,
      with: () =>
        throwError(
          () =>
            new Response(null, {
              status: StatusCode.Timout,
              statusText: 'Timeout',
            })
        ),
    }),
    tap((response) => {
      if (!response.ok) {
        throw response;
      }
    })
  );
}
